import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { formatCurrency } from "../utils/FormatCurrency";

function DialogConfirmacaoAvenida(props) {
  const [checkedConfirma, setCheckedConfirma] = useState(false);

  function aceiteFooter() {
    return (
      <div>
        <div className="loginCheckbox" style={{ textAlign: "center" }}>
          <Checkbox
            inputId="binary"
            className="loginCheckbox pb-[23px]"
            checked={checkedConfirma}
            onChange={(e) => setCheckedConfirma(e.checked)}
          />
          <label htmlFor="binary" className="text-[2vh]">
            Concordo com os termos de negociação
          </label>
        </div>
        <div className="mt-[1vh] continueButton w-full grid px-[20px]">
          <Button
            label="Confirmar"
            onClick={() => {
              props.close();
              props.aceite();
            }}
            disabled={!checkedConfirma}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="boletosDialog">
      <Dialog
        visible
        className="boletosDialog"
        onHide={() => props.close()}
        style={{
          minHeigth: "30vw",
          minWidth: "40vw",
          textAlign: "center",
          // borderRadius: '30px',
          // padding: '10px'
        }}
        draggable={false}
        header="Realizar Negociação"
        footer={aceiteFooter}
      >
        <div>
          <div>
            <h6>Confira as informações de negociação</h6>
          </div>
          <div className="boletosDialog mt-[1vh]">
            <h5 className="font-lato-bold mb-[1vh]">Cronograma de pagamento</h5>
            <DataTable value={props.cronograma} className="boletosDialog overflow-auto h-[35vh]">
              <Column field="parcela" header="Parcela" />
              <Column field="valor" header="Valor Parcela" />
              <Column field="dia_pagamento" header="Data Vencimento" />
            </DataTable>
          </div>
          <div className="mt-[1vh]">
            <h5 className="font-lato-bold">Total a Pagar</h5>
            <h4 className="font-lato-bold">{formatCurrency(props.valor_pagamento)}</h4>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default DialogConfirmacaoAvenida;
